'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './acctst.routes';

export class AcctstComponent {

  constructor(AccountingService) {
    'ngInject';

    this.AccountingService = AccountingService;
  }

  showId(id) {
    prompt('Journal ID',id);
  }

  getTransactions() {
    this.AccountingService.transactions({book: 'test', account: this.account}, data => {
      this.transactions = data;
    })
  }

  getJournal() {
    this.AccountingService.journal({book: 'test'}, data => {
      this.journal = data;
    })
  }

  getBalance() {
    this.AccountingService.balance({book: 'test', account: this.account}, data => {
      this.balance = data;
    })
  }

  voidEntry() {

    let body = (this.voidReason) ? {reason: this.voidReason} : {};

    this.AccountingService.void({book: 'test', id: this.voidId}, body, data => {
      this.voidResult = data;
    })
  }

  postEntry() {
    this.AccountingService.entry({book: 'test'}, {
      entry: this.entry,
      transactions: [{
        type: 'debit',
        account: this.debitAccount,
        amount: this.debitAmount
      },{
        type: 'credit',
        account: this.creditAccount,
        amount: this.creditAmount
      }]
    }, data => {
        this.entryResult = data;
    })
  }
}

export default angular.module('conduuApp.acctst', [uiRouter])
  .config(routes)
  .component('acctst', {
    template: require('./acctst.html'),
    controller: AcctstComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/accounting/test/acctst.component.js